import React from "react";
import Head from "next/head";
import Hero from "./Hero";
import OurUsers from "./OurUsers";
import OurEcosystem from "./OurEcosystem";
import FeaturedInitiatives from "./FeaturedInitiatives";
import NewsSection from "./NewsSection";
import EcosystemSection from "./EcosystemSection";
import Partners from "./Partners";

const LandingPage = () => {
  return (
    <>
      <Head>
        <title>Impactoverse | Art For Impact</title>
        <meta
          name="description"
          content="Impactoverse - A space to easily launch meaningful campaigns, back vetted causes, grow community, and build connections that scale impact."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.png" />
      </Head>

      <div className="flex flex-col min-h-screen bg-transparent dark:bg-transparent text-grayish dark:text-white">
        <main className="flex-grow">
          <Hero />
          <OurUsers />
          <FeaturedInitiatives />
          <NewsSection />
          <EcosystemSection />
          <Partners />
        </main>
      </div>
    </>
  );
};

export default LandingPage;
